import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    try {
      logout();
    } finally {
      navigate('/login', { replace: true });
      window.location.href = '/login';
    }
  }, [logout, navigate]);

  return <div />;
};

export default Logout;
